// The alarm on/off request, in one place (core ADR-218, TOM-136). The row's
// switch and "Turn off" on a withdrawn alarm send the same PATCH, so they
// cannot drift apart. Kept out of `alarmInlineEditor.ts`, which stays pure.

import { api } from '../api';
import type { DeliveryState } from './alarmDisplay';

/**
 * Switch one alarm on or off. Resolves to the delivery state the cloud reports
 * for the change (has the boat got it yet).
 */
export async function setAlarmEnabled(
  boatId: string,
  alarmId: string,
  enabled: boolean
): Promise<DeliveryState | undefined> {
  const res = await api<{ delivery?: { state?: DeliveryState } }>(
    `/v1/boats/${boatId}/alerts/${alarmId}`,
    { method: 'PATCH', body: { enabled }, idempotencyKey: crypto.randomUUID() }
  );
  return res.delivery?.state;
}

/**
 * Turn one alarm off — the one change an alarm on a withdrawn recipe still
 * accepts besides Delete. Shared by the full editor and the inline panel.
 */
export function turnOffAlarm(boatId: string, alarmId: string): Promise<DeliveryState | undefined> {
  return setAlarmEnabled(boatId, alarmId, false);
}
